module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"required":"required","required field":"Required field – cannot be removed"},"de":{"required":"Pflicht","required field":"Pflichtfeld – kann nicht entfernt werden"}}')
  delete Component.options._Ctor
}
